"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var singleMetricCard_1 = require("./single-metric/singleMetricCard");
var doubleMetricCard_1 = require("./double-metric/doubleMetricCard");
var reportStatsCards_styles_1 = require("./reportStatsCards.styles");
var luxon_1 = require("luxon");
var core_components_1 = require("@securityproducts/core-components");
var reportStatsCards_i18n_1 = require("./reportStatsCards.i18n");
function HistoricalReportStatsCards(props) {
    var strings = core_components_1.useLocalisation(reportStatsCards_i18n_1.reportsStatsTranslations, props.language);
    var timeLoggedInTitle = getTimeLoggedInTitle(props.limitedData, props.firstAvailableData, props.language);
    return (React.createElement("div", { className: reportStatsCards_styles_1.container },
        React.createElement(core_components_1.ErrorBoundary, null,
            React.createElement("div", { className: reportStatsCards_styles_1.doubleWrapper },
                React.createElement(doubleMetricCard_1.DoubleMetricCard, { totalCalls: props.totalCalls, rolledCalls: props.rolledCalls, language: props.language })),
            React.createElement("div", { className: reportStatsCards_styles_1.singleWrapper },
                !props.archiveMode && (React.createElement(singleMetricCard_1.SingleMetricCard, { id: "total-time-logged-in", title: timeLoggedInTitle, value: core_components_1.hoursMinutesSeconds(props.totalTimeLoggedIn, props.language) })),
                React.createElement(singleMetricCard_1.SingleMetricCard, { id: "max-talk-time", title: strings.maxTalkTime, value: core_components_1.hoursMinutesSeconds(props.maxTalkTime, props.language) }),
                React.createElement(singleMetricCard_1.SingleMetricCard, { id: "avg-talk-time", title: strings.avgTalkTime, value: core_components_1.hoursMinutesSeconds(props.avgTalkTime, props.language) })))));
}
exports.HistoricalReportStatsCards = HistoricalReportStatsCards;
function getTimeLoggedInTitle(limitedData, firstAvailableData, language) {
    var strings = core_components_1.useLocalisation(reportStatsCards_i18n_1.reportsStatsTranslations, language);
    if (limitedData && firstAvailableData !== undefined) {
        var date = luxon_1.DateTime.fromJSDate(new Date(firstAvailableData))
            .setLocale(language)
            .toFormat("MMM dd, yyyy");
        return strings.totalTimeLoggedInSince + " " + date + ")";
    }
    else {
        return strings.totalTimeLoggedIn;
    }
}
